import './anchor-navi.scss';

class AnchorNavigation {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-anchor-navi',
            anchorAttr: 'anchor',
            listAttr: 'list',
            itemAttr: 'item',
            speed: 400
        };

        this.settings = Object.assign({}, defaults, options);
        this.$anchorNavigation = element;
        this.$anchorNavigationScrollWrapper = this.$anchorNavigation.querySelector('[data-anchor-navi="scroll-wrapper"]');
        this.$anchorNavigationItems = this.$anchorNavigation.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.itemAttr + '"]');
        this.$anchorNavigationList = this.$anchorNavigation.querySelector('[' + this.settings.initAttr + '="' + this.settings.listAttr + '"]');
        this.$siteheader = document.querySelector('[data-siteheader="root"]');
        this.$metaNav = document.querySelector('[data-siteheader="meta-nav"]');
        this.$$anchors = document.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.anchorAttr + '"]');
        this.eventScroller = this.settings.eventScroller;
        this.queryParams = new URLSearchParams(window.location.search);
        this.allIds = [];
        this.allLabels = [];
        this.init();
    }

    init () {
        this.getAllIds();
        this.buildAnchorNav();
        this.checkAnchorPosition();
        this.setEvents();
    }

    setEvents () {
        if (this.queryParams.size > 0) {
            const anchor = this.queryParams.get('anchor');

            if (anchor) {
                const $targetHref = this.$anchorNavigation.querySelector(`a[href="#${anchor}"]`);

                if ($targetHref) {
                    this.scrollToTarget($targetHref);
                }
            }
        }

        window.eventScroller.customFunctions.push(() => {
            this.checkAnchorPosition();
        });

        this.$anchorNavigationItems.forEach($item => {
            const $currentItem = $item.querySelector('a[href]');

            $currentItem.addEventListener('click', (e) => {
                this.scrollToTarget($currentItem);
                e.preventDefault();
            });

            $currentItem.addEventListener('keydown', (e) => {
                if (e.code === 'Space' || e.code === 'Enter') {
                    this.scrollToTarget($currentItem);
                }
            });
        });
    }

    scrollToTarget ($currentItem) {
        let height = this.$anchorNavigation.offsetHeight + 10;
        const targetId = $currentItem.getAttribute('href').split('#')[1];
        const $target = document.getElementById(targetId);
        const siteHeaderHeightFold = this.$siteheader.offsetHeight;
        const siteHeaderHeightUnfold = siteHeaderHeightFold + this.$metaNav.offsetHeight;

        const currentScrollPosition = window.scrollY;
        const targetPosition = $target.getBoundingClientRect().top + currentScrollPosition;

        if (targetPosition > currentScrollPosition) {
            height += siteHeaderHeightFold;
        } else if (targetPosition < currentScrollPosition) {
            height += siteHeaderHeightUnfold;
        }

        document.documentElement.style.setProperty('--anchor-nav-top', `${height}px`);

        window.setTimeout(() => {
            $target.scrollIntoView({ behavior: 'smooth' });
        }, 150);
    }

    getAllIds () {
        this.$$anchors.forEach($anchor => {
            const anchorID = $anchor.getAttribute('id');
            const anchorLabel = $anchor.getAttribute('data-anchor-label');
            this.allIds.push(anchorID);
            this.allLabels.push(anchorLabel);
        });
    }

    buildAnchorNav () {
        this.allIds.forEach((id, i) => {
            const listItem = document.createElement('li');
            listItem.classList.add('anchor-navi__item');
            listItem.setAttribute('data-anchor-navi', 'item');

            const anchorItem = document.createElement('a');
            anchorItem.textContent += `${this.allLabels[i]}`;
            anchorItem.href = `#${this.allIds[i]}`;
            anchorItem.classList.add('anchor-item');
            anchorItem.setAttribute('aria-label', `Zu ${this.allLabels[i]} Bereich Scrollen`);
            listItem.appendChild(anchorItem);
            this.$anchorNavigationList.appendChild(listItem);
        });

        this.$anchorNavigationItems = this.$anchorNavigation.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.itemAttr + '"]');
    }

    setActiveAnchorItem (id) {
        this.$activeItem = '';
        if (id) { this.$activeItem = this.$anchorNavigation.querySelector('a[href="#' + id + '"]').parentNode; }

        for (let a = 0; a < this.$anchorNavigationItems.length; a++) {
            const $currentItem = this.$anchorNavigationItems[a];

            if ($currentItem === this.$activeItem) {
                $currentItem.classList.add('is--active');
            } else {
                $currentItem.classList.remove('is--active');
            }

            if ($currentItem === this.$activeItem) {
                const containerRect = this.$anchorNavigationScrollWrapper.getBoundingClientRect();
                const currentRect = this.$activeItem.getBoundingClientRect();
                let scrollOffset = 0;

                if (currentRect.left < containerRect.left) {
                    scrollOffset = currentRect.left - containerRect.left - 50;
                } else if (currentRect.right > containerRect.right) {
                    scrollOffset = currentRect.right - containerRect.right + 50;
                }

                if (scrollOffset !== 0) {
                    this.$anchorNavigationScrollWrapper.scrollLeft += scrollOffset;
                }
            }
        }
    }

    checkAnchorPosition () {
        let newActiveId = null;

        this.$$anchors.forEach($anchor => {
            const elementDimensions = $anchor.getBoundingClientRect();
            const elementTop = elementDimensions.top;
            const elementBottom = elementDimensions.bottom;

            const isInViewport = elementTop < window.innerHeight && elementBottom >= 0;

            if (isInViewport && elementTop <= window.innerHeight / 2) {
                newActiveId = $anchor.getAttribute('id');
            }
        });

        if (newActiveId && this.activeAnchorId !== newActiveId) {
            this.activeAnchorId = newActiveId;
            this.setActiveAnchorItem(this.activeAnchorId);
        }
    }
}

export { AnchorNavigation };

window.addEventListener('content.loaded', (e) => {
    const $context =  e.detail.$context;

    if ($context) {
        const $$AnchorNavigation = $context.querySelectorAll('[data-anchor-navi="root"]');

        for (let i = 0; i < $$AnchorNavigation.length; i++) {
            const $AnchorNavigation = $$AnchorNavigation[i];
            const AnchorNavigationAPI = new AnchorNavigation($AnchorNavigation);
            $AnchorNavigation.API = AnchorNavigationAPI;
        }
    }
});
